<template>
    <div class="inline-block">
        <AppButton @click="open = !open" element="button" type="button" :desired-action="questionCount === 0">
            {{ $t('messages.import') }}
        </AppButton>
    </div>
    <SlideOver :show="open" @close="open = false" :title="$t('messages.import')">
        <div>
            <AlertMessage class="mt-5 inline-block" type="info">
                <template v-slot:title>
                    {{ $t('messages.information') }}
                </template>
                <template v-slot:body>
                    <AppButton :href="endpoint.template_url" target="_blank">{{ $t('messages.template') }}</AppButton>
                </template>
            </AlertMessage>
        </div>
        <form :action="endpoint.url" @submit.prevent="submit">
            <input
                id="image"
                @input="form.csv = $event.target.files[0]"
                name="csv"
                type="file"
                accept=".csv, text/csv"
                class="mt-1 w-full"
            />
            <FormError :value="form.errors.csv" />
            <AppButton desired-action element="button" type="submit" :disabled="form.processing" class="mt-3">
                {{ $t('messages.save') }}
                <span v-if="form.processing" class="ml-1 btn-spinner"></span>
            </AppButton>
        </form>
    </SlideOver>
</template>

<script>
import SlideOver from '@/components/SlideOver.vue';
import AppButton from '@/components/AppButton.vue';
import FormError from '@/components/Forms/FormError.vue';
import AlertMessage from '@/components/AlertMessage.vue';

export default {
    name: 'ImportActivityQuestionsPanel',
    components: {
        FormError,
        SlideOver,
        AppButton,
        AlertMessage,
    },
    data() {
        return {
            open: false,
            form: this.$inertia.form({
                csv: null,
            }),
        };
    },
    props: {
        endpoint: {
            type: Object,
            required: true,
        },
        questionCount: {
            type: Number,
            required: false,
            default: 0,
        },
    },
    methods: {
        submit() {
            this.form.post(this.endpoint.url, {
                forceFormData: true,
                onSuccess: () => {
                    this.open = false;
                },
            });
        },
    },
};
</script>
